import React, { useState, useEffect } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { ESSENTIALDETAIL } from "../../../../services/ApiCalls";
import moment from "moment";
import { catchAsync, checkResponse } from "../../../../utilities/utilities";
import Loader from "../../../../components/Common/Loader";

const AmenitiesDetail = () => {
  const [amenities, setAmenities] = useState();
  const [loader, setLoader] = useState(false);
  const { id } = useParams();

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await ESSENTIALDETAIL(id);
    checkResponse({ res, setData: setAmenities, setLoader }, setLoader);
  });

  useEffect(() => {
    if (id) getData();
  }, [id]);

  return (
    <>
      {loader && <Loader />}

      <section className="py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-2">
                <Link
                  to="/amenities"
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#E8307A"
                      stroke="#E8307A"
                      strokeWidth="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 fw-bold text-dark text-capitalize">
                  Amenities Details
                </h4>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg="12" className="my-3">
              <div className="p-4 rounded" style={{ background: "#EEEEEE" }}>
                <Row className="justify-content-between">
                  <Col
                    md={4}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <img
                      src={amenities?.imgUrl}
                      alt={amenities?.name}
                      className="img-fluid rounded shadow-sm"
                      style={{ maxHeight: "250px", objectFit: "contain" }}
                    />
                  </Col>

                  <Col md={8} className="mt-3 mt-md-0">
                    <ul className="list-unstyled">
                      <li className="py-2 d-flex align-items-center">
                        <p className="m-0 fw-semibold w-50 text-dark">
                          Amenity Name:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {amenities?.name || "-"}
                        </h6>
                      </li>

                      <li className="py-2 d-flex align-items-center">
                        <p className="m-0 fw-semibold w-50 text-dark">Type:</p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {amenities?.type || "-"}
                        </h6>
                      </li>

                      <li className="py-2 d-flex align-items-center">
                        <p className="m-0 fw-semibold w-50 text-dark">
                          Status:
                        </p>
                        <div className="d-flex align-items-center w-50">
                          <Form.Check
                            type="switch"
                            id="status-switch"
                            checked={amenities?.status === "active"}
                            readOnly
                          />
                          <span
                            className={`ms-2 fw-bold ${
                              amenities?.status === "active"
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            {amenities?.status === "active"
                              ? "Active"
                              : "Inactive"}
                          </span>
                        </div>
                      </li>

                      <li className="py-2 d-flex align-items-start">
                        <p className="m-0 fw-semibold w-50 text-dark">
                          Description:
                        </p>
                        <p
                          className="m-0 text-muted w-50"
                          style={{ fontSize: "14px", lineHeight: "20px" }}
                        >
                          {amenities?.description || "-"}
                        </p>
                      </li>

                      <li className="py-2 d-flex align-items-center">
                        <p className="m-0 fw-semibold w-50 text-dark">
                          Created At:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {amenities?.createdAt
                            ? moment(amenities.createdAt).format("YYYY-MM-DD")
                            : "-"}
                        </h6>
                      </li>

                      <li className="py-2 d-flex align-items-center">
                        <p className="m-0 fw-semibold w-50 text-dark">
                          Updated At:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {amenities?.updatedAt
                            ? moment(amenities.updatedAt).format("YYYY-MM-DD")
                            : "-"}
                        </h6>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AmenitiesDetail;
